export default "__VITE_ASSET__e618c275__"